import { render, staticRenderFns } from "./DocenteTipos.vue?vue&type=template&id=64b94c9f&"
import script from "./DocenteTipos.vue?vue&type=script&lang=js&"
export * from "./DocenteTipos.vue?vue&type=script&lang=js&"
import style0 from "./DocenteTipos.vue?vue&type=style&index=0&id=64b94c9f&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports